// Typed text -> contract values, for the non-money fields.
//
// Every one of these returns `NaN` (or leaves the value out) rather than
// guessing, so a half-typed number fails the shared schema on ITS OWN FIELD
// instead of arriving at the API as 0. Money has its own pair in
// `format/money.ts` — minor units are the one conversion that must never touch
// a float.

/** A percentage or a quantity. Blank and unparseable are both `NaN`. */
export function parseDecimal(input: string): number {
  const trimmed = input.trim();
  if (trimmed === "") return Number.NaN;
  if (!/^-?\d*(?:\.\d*)?$/.test(trimmed)) return Number.NaN;
  return Number(trimmed);
}

/** A whole number — contract term months. */
export function parseInteger(input: string): number {
  const trimmed = input.trim();
  if (!/^-?\d+$/.test(trimmed)) return Number.NaN;
  return Number(trimmed);
}

/**
 * An optional numeric field: blank means "not set" (`null`), which is a
 * different statement from zero. `cost_split_pct: null` is "cost splitting
 * isn't part of this agreement"; `0` is "we bear none of it".
 */
export function parseOptionalDecimal(input: string): number | null {
  return input.trim() === "" ? null : parseDecimal(input);
}

export function parseOptionalInteger(input: string): number | null {
  return input.trim() === "" ? null : parseInteger(input);
}

/** Optional free text. An empty textarea is `null`, not `""`. */
export function optionalText(input: string): string | null {
  const trimmed = input.trim();
  return trimmed === "" ? null : trimmed;
}

/** An optional calendar date or period: blank is `null`. */
export function optionalDate(input: string): string | null {
  return input.trim() === "" ? null : input.trim();
}

/** The reverse, for loading a record into a draft. */
export function textOf(value: string | number | null): string {
  return value === null ? "" : String(value);
}
